/* eslint-disable react/no-danger -- Rich text is sanitized with DOMPurify before rendering. */
import React, { useEffect, useState } from 'react';
import { connect, history } from 'umi';
import moment from 'moment';
import DOMPurify from 'dompurify';
import { isEmpty } from 'lodash';

import QRCode from 'qrcode.react';

import { Toast } from 'antd-mobile';
import { Button, Modal, Text } from '@digitalc/dxp-ui';
import copy from 'copy-to-clipboard';

import { BaseSpin, Clickable } from '@/components';

import { formatDate, onHistoryPush, dateFormat, goBack } from '@/utils/utils';
import { CouponStateOption } from '@/utils/constants';
import copyIcon from '@/assets/images/point/copy.svg';
import useResponsive from '@/hooks/useResponsive';
import useGCPI18n from '@/hooks/useGCPI18n';
import pointHistoryInco from '@/assets/images/point/pointHistoryInco.png';
import cardLeft from '@/assets/images/card_left.png';
import cardRight from '@/assets/images/card_right.png';
import cardLeftMask from '@/assets/images/card_left_mask.png';
import cardRightMask from '@/assets/images/card_right_mask.png';
import convertFail from '@/assets/images/point/convertFail.png';
import convertSuccess from '@/assets/images/point/convertSuccess.png';

import voucherDefault from '@/assets/images/point/defaultVoucherImg.png';
import voucherExpired from '@/assets/images/point/voucherExpired.png';
import voucherUsed from '@/assets/images/point/voucherUsed.png';
import voucherValid from '@/assets/images/point/voucherValid.png';
import rewardDate from '@/assets/images/reward_date.svg';

import Header from '../Header';
import styles from './index.less';

const { VALID, EXPIRED, USED } = CouponStateOption;
const VoucherDetail = props => {
  const { loading, dispatch } = props;
  const [detail, setDetail] = useState({});
  const [claimResult, setClaimResult] = useState({});
  const {
    couponState,
    couponName,
    couponSn,
    couponImageUrl,
    couponDesc,
    claimState,
    expDate,
    effDate,
    availableRedeemList,
    redeemEndTime,
    redeemStartTime,
    redeemList,
    claimStartDate,
    claimEndDate,
  } = detail;

  const isVaild = couponState === VALID; // 可使用
  const isExpried = couponState === EXPIRED; // 过期
  const isUsed = couponState === USED; // 已使用
  const isRedeem = !isEmpty(availableRedeemList);
  const needClaim = isVaild && claimState === 'U'; // 需要手动领取
  const disabled = isExpried || isUsed;

  const now = moment();
  const notStart = !now.isAfter(moment(effDate)); // 未开始
  const canRedeem = isVaild && !notStart && now.isBefore(moment(expDate)); // 已开始，可兑换

  // 响应式 hook
  useResponsive();
  const GCPI18n = useGCPI18n();

  const { couponInstId, couponSn: _couponSn, channel } = history.location.query;

  const getVoucherStatePicture = () => {
    if (isVaild) {
      return voucherValid;
    }
    if (isExpried) {
      return voucherExpired;
    }
    if (isUsed) {
      return voucherUsed;
    }
    return null;
  };

  const copySuccess = GCPI18n({ id: 'lb_point_my_voucher_copy_successfully' });
  const handleCopy = value => {
    copy(value);
    Toast.show({ icon: 'success', content: copySuccess });
  };

  const handleRedeem = async () => {
    onHistoryPush('/pointshop/redeemList');
  };

  const handleClaim = async () => {
    const data =
      (await dispatch({
        type: 'pointShop/claimCoupon',
        payload: {
          couponInstId: detail.couponInstId,
        },
      })) || {};
    const success = !isEmpty(data);
    if (success) {
      if (!isEmpty(data?.couponSn)) {
        onHistoryPush('/pointshop/claimSuccessfull', { detail: data });
        return;
      }
    }
    setClaimResult({
      open: true,
      success,
    });
  };

  const handleDetailQuery = async id => {
    const res = await dispatch({
      type: 'pointShop/queryCouponDetail',
      payload: {
        couponInstId: id || couponInstId,
        couponSn: _couponSn,
      },
    });
    const { redeemEndTime: _redeemEndTime, expDate: _expDate } = res || {};
    // 失效时间
    let minTime = _redeemEndTime || '';
    if (isEmpty(_redeemEndTime) && !isEmpty(_expDate)) {
      minTime = _expDate;
    } else if (!isEmpty(_redeemEndTime) && !isEmpty(_expDate)) {
      // 失效了不能兑换，超过了兑换截止时间，也不能兑换
      // 直接对比并获取最小时间
      minTime = moment(_expDate).isBefore(moment(_redeemEndTime)) ? _expDate : _redeemEndTime;
    }
    dispatch({
      type: 'pointShop/updateState',
      payload: {
        voucherDetail: {
          ...res,
          expDate: minTime,
        },
      },
    });
    setDetail(res);
  };

  useEffect(() => {
    if (couponInstId) {
      handleDetailQuery();
    } else if (channel === 'pb') {
      // 演示使用，演示结束后必须删除这段逻辑
      let voucherPayload = {
        startDate: dateFormat(moment().add(1, 'days').subtract(1, 'months').locale('en')),
        endDate: dateFormat(moment().add(1, 'days').locale('en')),
        pageIndex: 1,
        pageSize: 100,
        // couponState,
        partyType: 'INDIVIDUAL',
      };
      if (couponState) {
        voucherPayload = { ...voucherPayload, couponState };
      }
      dispatch({
        type: 'index/qryVoucherListDXP',
        payload: voucherPayload,
      }).then(voucherListTemp => {
        // setVoucherList(voucherListTemp);
        const defaultVoucher = voucherListTemp?.[0] || {};
        if (defaultVoucher.couponInstId) {
          handleDetailQuery(defaultVoucher.couponInstId);
        }
      });
    }
  }, [couponInstId, channel]);

  const renderCardBg = () => {
    let needLine = !isExpried && !isEmpty(couponSn);
    if (isUsed) {
      needLine = !isEmpty(redeemList);
    }
    return (
      <div className={`${styles.bgCard} ${needLine && styles.needLine}`}>
        <img src={isVaild ? cardLeft : cardLeftMask} alt="" className={styles.cardLeft} />
        <div className={styles.line} />
        <img src={isVaild ? cardRight : cardRightMask} alt="" className={styles.cardRight} />
      </div>
    );
  };

  const renderTime = () => {
    const timeObj = {};
    // 可兑换券
    const exp = formatDate(expDate);
    if (isVaild) {
      // 1、当前时间到endTime <= 7 天，展示 Expiring in 7 days，注意： 7 是变化的 #ED1D23
      // 2、当前时间到endTime > 7天，展示  Redeemable Period: 1 Jun 2025 - 17 Sep 2025
      const today = moment().startOf('day');
      // 计算相差的天数
      const daysRemaining = moment(expDate).diff(today, 'days');
      if (daysRemaining > 7) {
        timeObj.dataText = `${GCPI18n({ id: 'lb_my_rewards_all_card_valid_till' })} ${exp}`;
      } else if (daysRemaining <= 0) {
        timeObj.dataText = GCPI18n({ id: 'lb_no_expiry' });
      } else {
        timeObj.className = styles.waring;
        timeObj.dataText = `${GCPI18n({
          id: 'lb_my_rewards_all_card_expiring_in',
        })} ${daysRemaining} ${GCPI18n({ id: 'lb_my_rewards_all_card_days' })}`;
      }
    }
    if (isExpried) {
      timeObj.className = styles.waring;
      timeObj.dataText = GCPI18n({ id: 'lb_my_rewards_all_card_expired' });
    }
    if (isUsed) {
      timeObj.dataText = GCPI18n({ id: 'lb_full_redeem' });
    }
    if (isRedeem) {
      // 4、used 状态展示 1 Jun 2025 - 17 Sep 2025
      if (isExpried) {
        // 3、过期状态，展示 Expired on 1 Jun 2025 #ED1D23
        timeObj.className = styles.waring;
        timeObj.dataText = `${GCPI18n({ id: 'lb_expired_on' })} ${exp}`;
      }
      if (isUsed) {
        timeObj.dataText = `${GCPI18n({ id: 'lb_redeemabled_period' })}: ${formatDate(
          redeemStartTime,
        )} - ${formatDate(redeemEndTime)}`;
      }
    }
    if (needClaim) {
      timeObj.dataText = `${GCPI18n({ id: 'lb_claim_period' })}: ${formatDate(
        claimStartDate,
      )} - ${formatDate(claimEndDate)}`;
    }
    return timeObj;
  };

  const getDisabled = () => {
    const res = now.isAfter(moment(claimStartDate)) && now.isAfter(moment(claimEndDate));
    return res;
  };

  const renderVoucherDetail = () => {
    const { dataText, className } = renderTime();

    return (
      <div className={styles.voucherDetail}>
        <div className={`${styles.content} ${disabled && styles.disabled}`}>
          <div className={styles.detail}>
            <div className={styles.left}>
              <img src={couponImageUrl || voucherDefault} alt="" />
            </div>
            <div className={styles.right}>
              <div className={styles.voucherName}>{couponName}</div>
              <div className={`${styles.timeBox} ${className}`}>
                <img src={rewardDate} alt="" />
                {dataText}
              </div>
            </div>
            <div className={styles.stateWrap}>
              <img src={getVoucherStatePicture()} alt="" />
            </div>
            {renderCardBg()}
          </div>
          {isUsed && !isEmpty(redeemList) && (
            <div className={styles.redeemListBox}>
              <div className={styles.title}>{GCPI18n({ id: 'lb_redemption_details' })}</div>
              <div className={styles.redeemList}>
                {redeemList.map((it, i) => (
                  <div className={styles.item} key={it.objCode}>
                    <div className={styles.label}>
                      {GCPI18n({ id: 'lb_prize_voucher' })} {i + 1}
                    </div>
                    <div className={styles.value}>{it.objName}</div>
                  </div>
                ))}
                <div className={styles.item}>
                  <div className={styles.label}>{GCPI18n({ id: 'lb_redemption_ime' })}</div>
                  <div className={styles.value}>{formatDate(redeemList[0].redeemTime)}</div>
                </div>
              </div>
            </div>
          )}
          {couponSn && isVaild && (
            <div className={styles.qrCodeBox}>
              <QRCode className={styles.qrCode} value={couponSn} level="H" />
              <div className={styles.codeWrap}>
                {GCPI18n({
                  id: 'lb_point_my_voucher_code',
                })}
                : {couponSn}
                <span className={styles.copy}>
                  {GCPI18n({ id: 'btn_copy' })}
                  <Clickable as="img" src={copyIcon} alt="" onClick={() => handleCopy(couponSn)} />
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const goHome = () => {
    if (channel === 'pb') {
      goBack();
      return;
    }
    history.goBack();
  };
  return (
    <div className={styles.voucherDetailWrap}>
      <Header
        title={GCPI18n({
          id: 'lb_point_my_voucher_details',
        })}
        goHome={goHome}
      />
      {disabled && <div className={styles.isExpried} />}
      <BaseSpin spinning={loading}>
        {!isEmpty(detail) && (
          <>
            {renderVoucherDetail()}
            {couponDesc && (
              <div className={styles.voucherDescWrap}>
                <div className={styles.title}>
                  {GCPI18n({
                    id: 'lb_point_my_voucher_how_to_use',
                  })}
                  :
                </div>
                <div
                  className={styles.content}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(couponDesc || ''),
                  }}
                />
              </div>
            )}
            {isRedeem && isVaild && (
              <div className={styles.footer}>
                {notStart && (
                  <div className={styles.tipBox}>
                    <img src={pointHistoryInco} alt="" />
                    <div className={styles.info}>
                      <div className={styles.title}>
                        {GCPI18n({ id: 'tip_voucher_redeem_start' })}
                      </div>
                      <div className={styles.tip}>
                        {GCPI18n({ id: 'tip_voucher_redeem_start_2' })}
                      </div>
                    </div>
                  </div>
                )}
                <div className={styles.btnBox}>
                  {!needClaim && (
                    <Button
                      disabled={!canRedeem}
                      type="primary"
                      className={styles.submitBtn}
                      onClick={handleRedeem}
                    >
                      {GCPI18n({ id: 'lb_order_redeem' })}
                    </Button>
                  )}
                  {needClaim && (
                    <Button
                      disabled={getDisabled()}
                      type="primary"
                      className={styles.submitBtn}
                      onClick={handleClaim}
                    >
                      {GCPI18n({ id: 'lb_my_rewards_all_card_claim' })}
                    </Button>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </BaseSpin>
      {claimResult.open && (
        <Modal
          breakpoint="mobile"
          size="50%"
          open={claimResult.open}
          onCancel={() => {
            if (claimResult.success) {
              return;
            }
            setClaimResult({});
          }}
          className={`${styles.failModal} ${claimResult.success ? styles.successModal : ''}`}
          footer={(
            <div className={styles.failBtns}>
              {claimResult.success ? (
                <Button
                  type="primary"
                  onClick={() => {
                    setClaimResult({});
                    onHistoryPush('/pointshop/myVoucher');
                  }}
                  className={styles.primary}
                  style={{ color: '#ffffff' }}
                >
                  {GCPI18n({ id: 'lb_back_my_voucher' })}
                </Button>
              ) : (
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      setClaimResult({});
                    }}
                    className={styles.primary}
                    style={{ color: '#ffffff' }}
                  >
                    {GCPI18n({ id: 'lb_dito_failed_page_try_again' })}
                  </Button>
                  <Button
                    className={styles.cancel}
                    onClick={() => {
                      setClaimResult({});
                      onHistoryPush('/pointshop/myVoucher');
                    }}
                  >
                    {GCPI18n({ id: 'lb_point_my_voucher' })}
                  </Button>
                </>
              )}
            </div>
          )}
        >
          <div className={styles.contentWrap}>
            <div className={styles.errImg}>
              <img src={claimResult.success ? convertSuccess : convertFail} alt="" />
            </div>
            <div style={{ textAlign: 'center' }}>
              <Text breakpoint="Mobile" size="TitleT23Bold" style={{ fontFamily: 'Roboto' }}>
                {GCPI18n({
                  id: claimResult.success
                    ? 'lb_my_rewards_all_detail_claim_success'
                    : 'lb_my_rewards_all_detail_claim_failed',
                })}
              </Text>
              <Text
                breakpoint="Mobile"
                size="ContentC14Regular"
                style={{ fontFamily: 'Roboto', display: 'block', marginTop: '0.16rem' }}
              >
                {GCPI18n({
                  id: claimResult.success
                    ? 'tip_claim_voucher_success'
                    : 'lb_my_rewards_all_detail_claim_failed_msg',
                })}
              </Text>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default connect(({ loading }) => ({
  loading: loading.effects['pointShop/queryCouponDetail'] || false,
}))(VoucherDetail);
